// Buying options
document.addEventListener("DOMContentLoaded", () => {
  const allBuyingContainers = document.querySelectorAll(
    ".selector__buying-container"
  );
  allBuyingContainers.forEach((container) => {
    const buyingOptionItems = container.querySelectorAll(
      ".selector__buying-option"
    );
    buyingOptionItems.forEach((option) => {
      option.addEventListener("click", () => {
        buyingOptionItems.forEach((opt) => opt.classList.remove("active"));
        option.classList.add("active");
      });
    });
  });
});

// Tab buttons and color management
document.addEventListener("DOMContentLoaded", () => {
  const allTabButtons = document.querySelectorAll(".selector__tab-button");
  const allSections = document.querySelectorAll(
    ".product-selector__color-changer"
  );

  window.currentSelectedType = "screw-in";

  const activeTab =
    document.querySelector(".selector__tab-button.active") || allTabButtons[0];
  if (activeTab) {
    window.currentSelectedType = activeTab.dataset.type;
    applyColors(activeTab.dataset);
    updateProductVariant(activeTab.dataset.type);
  }

  allTabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      window.currentSelectedType = button.dataset.type;
      applyColors(button.dataset);

      const currentCard = button.closest(
        ".selector__product-card, .unified-slide__card"
      );
      if (currentCard) {
        const currentCardTabButtons = currentCard.querySelectorAll(
          ".selector__tab-button"
        );
        currentCardTabButtons.forEach((btn) => {
          btn.classList.toggle(
            "active",
            btn.dataset.type === button.dataset.type
          );
        });
      }

      updateProductVariant(button.dataset.type, button);
    });
  });

  function applyColors(dataset) {
    allSections.forEach((section) => {
      section.style.setProperty("--color-120", dataset["color-120"]);
      section.style.setProperty("--color-110", dataset["color-110"]);
      section.style.setProperty("--color-100", dataset["color-100"]);
      section.style.setProperty("--color-70", dataset["color-70"]);
      section.style.setProperty("--color-40", dataset["color-40"]);
      section.style.setProperty("--color-30", dataset["color-30"]);
      section.style.setProperty("--color-20", dataset["color-20"]);
      section.style.setProperty("--color-5", dataset["color-5"]);
      section.style.setProperty("--color-radial", dataset["colorRadial"]);
      section.style.setProperty("--color-linear-end", dataset["colorLinearEnd"] || dataset["color-100"]);
    });
  }

  function updateProductVariant(type, button = null, card = null) {
    const activeCard = card || (button ? button.closest(
      ".selector__product-card.active, .unified-slide__card.active"
    ) : document.querySelector(
      ".selector__product-card.active, .unified-slide__card.active"
    ));
    if (!activeCard) return;

    const productTypesContainer = activeCard.querySelector(
      ".tabs-container.selector__product-types"
    );
    if (!productTypesContainer) return;

    let variantId;
    if (type === "screw-in") {
      variantId = productTypesContainer.dataset.screwInVariant;
    } else if (type === "snap-in") {
      variantId = productTypesContainer.dataset.snapInVariant;
    }

    if (!variantId) return;

    const addToCartButton = activeCard.querySelector("add-to-cart");
    if (addToCartButton) {
      addToCartButton.setAttribute("data-variant-id", variantId);
      addToCartButton.setAttribute("data-current-type", type);
    }

    // Update featured image based on variant type
    updateFeaturedImage(type, productTypesContainer);
  }

  function updateFeaturedImage(type, productTypesContainer) {
    if (!productTypesContainer) return;

    const currentCard = productTypesContainer.closest(
      ".selector__product-card, .unified-slide__card"
    );
    if (!currentCard) return;

    // Get the featured image based on variant type
    let featuredImageUrl = null;

    if (type === "snap-in") {
      const snapInProduct = productTypesContainer.dataset.snapInProduct;
      if (snapInProduct) {
        featuredImageUrl = productTypesContainer.dataset.snapInFeaturedImage;
      }
    } else if (type === "screw-in") {
      featuredImageUrl = productTypesContainer.dataset.screwInFeaturedImage;
    }

    if (featuredImageUrl) {
      // For mobile: find the corresponding image in the image slider
      const mobileCard = currentCard.closest(".unified-slide__card");
      if (mobileCard) {
        // Get the card index from data-product-index
        const cardIndex = parseInt(mobileCard.dataset.productIndex, 10);
        const imageSlider = document.querySelector(".unified-image-slider");
        if (imageSlider && !isNaN(cardIndex)) {
          // Images have cloned slides, so real images are at indices 1 to n
          // Image with data-image-index matching cardIndex is the real image
          const targetImage = imageSlider.querySelector(`.unified-slide__image[data-image-index="${cardIndex}"]`);
          if (targetImage) {
            const img = targetImage.querySelector("picture img");
            if (img) {
              img.src = featuredImageUrl;
            }
          }
        }
      }

      // For desktop: find the corresponding image in the ProductImageSlider
      const productCard = currentCard.closest(".selector__product-card");
      if (productCard) {
        const allCards = Array.from(document.querySelectorAll(".selector__product-card"));
        const cardIndex = allCards.indexOf(productCard);

        if (cardIndex >= 0) {
          const imageSlider = document.querySelector("#ProductImageSlider");
          if (imageSlider) {
            const allPictures = imageSlider.querySelectorAll("picture");
            if (cardIndex < allPictures.length) {
              const picture = allPictures[cardIndex];
              const img = picture.querySelector("img");
              if (img) {
                img.src = featuredImageUrl;
              }
            }
          }
        }
      }
    }
  }

  window.updateProductVariant = updateProductVariant;
  window.applyColors = applyColors;
});

// Main slider logic
document.addEventListener("DOMContentLoaded", () => {
  const isMobile = () => window.innerWidth <= 768;

  // MOBILE: Separate image slider and fading cards
  const mobileSliderContainer = document.getElementById("UnifiedMobileSlider");
  const mobileImageSlider = document.querySelector(".unified-image-slider");
  const mobileCardsContainer = document.querySelector(".unified-cards-container");
  const mobileNextBtn = document.getElementById("SelectorNextButtonMobile");
  const mobilePrevBtn = document.getElementById("SelectorPrevButtonMobile");
  const mobileTabs = document.querySelector(".selector__product-tabs--mobile");

  // DESKTOP: Separate sliders
  const productCardSlider = document.getElementById("ProductCardSlider");
  const imageSlider = document.getElementById("ProductImageSlider");
  const desktopNextBtn = document.getElementById("SelectorNextButton");
  const desktopPrevBtn = document.getElementById("SelectorPrevButton");

  let currentIndex = 0;
  let isTransitioning = false;
  let isProgrammaticScroll = false;

  // Initialize based on viewport
  function init() {
    if (isMobile()) {
      initMobile();
    } else {
      initDesktop();
    }
  }

  // ===========================================
  // MOBILE: Horizontal image slider with fading cards
  // Images: [Clone of Last] [Real Images...] [Clone of First]
  // Cards: Stacked and fade based on active image
  // ===========================================
  let mobileRealSlideCount = 0; // Number of real slides (excluding clones)

  function initMobile() {
    if (!mobileImageSlider) return;

    const allImageSlides = Array.from(mobileImageSlider.querySelectorAll(".unified-slide__image"));
    const allCards = mobileCardsContainer ? Array.from(mobileCardsContainer.querySelectorAll(".unified-slide__card")) : [];

    if (allImageSlides.length === 0) return;

    // Count real slides (exclude cloned slides)
    mobileRealSlideCount = allImageSlides.filter(slide => !slide.hasAttribute("data-cloned")).length;

    // Start at index 1 (first real slide, after the cloned last slide)
    currentIndex = 1;

    // Set initial scroll position to the first real slide (without animation)
    const slideWidth = mobileImageSlider.offsetWidth;
    mobileImageSlider.scrollLeft = slideWidth; // Index 1

    updateMobileActiveSlide(currentIndex);

    // Listen for scroll events to update active state and handle wrap-around
    let scrollTimeout = null;
    mobileImageSlider.addEventListener("scroll", () => {
      // Ignore scroll events triggered by programmatic scrolling
      if (isProgrammaticScroll) return;

      // Clear previous timeout
      if (scrollTimeout) clearTimeout(scrollTimeout);

      // Debounce to detect when scrolling stops
      scrollTimeout = setTimeout(() => {
        const slideWidth = mobileImageSlider.offsetWidth;
        const scrollLeft = mobileImageSlider.scrollLeft;
        const newIndex = Math.round(scrollLeft / slideWidth);

        if (newIndex !== currentIndex && newIndex >= 0 && newIndex < allImageSlides.length) {
          currentIndex = newIndex;

          // Handle wrap-around for infinite scroll
          handleMobileWrapAround();
        }
      }, 50);
    }, { passive: true });
  }

  // Handle wrap-around when user swipes to cloned slides
  function handleMobileWrapAround() {
    const allImageSlides = mobileImageSlider.querySelectorAll(".unified-slide__image");
    const totalSlides = allImageSlides.length;
    const lastRealIndex = totalSlides - 2; // Last real slide index (before the clone of first)

    // If on clone of last slide (index 0), jump to the last real slide
    if (currentIndex === 0) {
      isProgrammaticScroll = true;
      setTimeout(() => {
        currentIndex = lastRealIndex;
        scrollMobileImageTo(currentIndex, false);
        updateMobileActiveSlide(currentIndex);
        setTimeout(() => {
          isProgrammaticScroll = false;
        }, 50);
      }, 300); // Wait for scroll-snap animation to complete
    }
    // If on clone of first slide (last index), jump to the first real slide
    else if (currentIndex === totalSlides - 1) {
      isProgrammaticScroll = true;
      setTimeout(() => {
        currentIndex = 1;
        scrollMobileImageTo(currentIndex, false);
        updateMobileActiveSlide(currentIndex);
        setTimeout(() => {
          isProgrammaticScroll = false;
        }, 50);
      }, 300); // Wait for scroll-snap animation to complete
    } else {
      updateMobileActiveSlide(currentIndex);
    }
  }

  function updateMobileActiveSlide(index) {
    const allImageSlides = mobileImageSlider ? Array.from(mobileImageSlider.querySelectorAll(".unified-slide__image")) : [];
    const allCards = mobileCardsContainer ? Array.from(mobileCardsContainer.querySelectorAll(".unified-slide__card")) : [];

    // Update image slides active state
    allImageSlides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add("active");
      } else {
        slide.classList.remove("active");
      }
    });

    // Convert slider index to card index (cards don't have clones)
    // Index 0 is clone of last, indices 1 to mobileRealSlideCount are real, last index is clone of first
    let cardIndex = index - 1; // Subtract 1 because index 0 is the clone

    // Handle wrap-around for clones
    if (cardIndex < 0) {
      cardIndex = mobileRealSlideCount - 1; // Clone of last -> last card
    } else if (cardIndex >= mobileRealSlideCount) {
      cardIndex = 0; // Clone of first -> first card
    }

    // Update cards - fade the corresponding card
    allCards.forEach((card, i) => {
      if (i === cardIndex) {
        card.classList.add("active");
        // Apply preserved state (screw-in/snap-in selection)
        applyPreservedState(card);
      } else {
        card.classList.remove("active");
      }
    });

    // Update mobile product tab buttons
    updateMobileProductTabButtons(index);

    // Clear any stuck active/focus states
    blurAllInteractiveElements();
  }

  function updateMobileProductTabButtons(index) {
    const tabs = document.querySelectorAll(".selector__product-tab--mobile");
    if (tabs.length === 0) return;

    const realProductCount = tabs.length;

    // Account for cloned slide at the beginning (index 0 is clone of last)
    // Real slides are at indices 1 to realProductCount
    // Index at the end (realProductCount + 1) is clone of first
    let realIndex = index - 1; // Subtract 1 because index 0 is the clone

    // Handle wrap-around for clones
    if (realIndex < 0) {
      realIndex = realProductCount - 1; // Clone of last -> last product
    } else if (realIndex >= realProductCount) {
      realIndex = 0; // Clone of first -> first product
    }

    tabs.forEach((tab) => {
      const tabProductIndex = parseInt(tab.dataset.productIndex, 10);
      if (tabProductIndex === realIndex) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });
  }

  function scrollMobileImageTo(index, animated = true) {
    if (!mobileImageSlider) return;
    const slideWidth = mobileImageSlider.offsetWidth;
    mobileImageSlider.scrollTo({
      left: index * slideWidth,
      behavior: animated ? "smooth" : "auto",
    });
  }

  function handleMobileNext() {
    if (isTransitioning || !mobileImageSlider) return;
    const allImageSlides = mobileImageSlider.querySelectorAll(".unified-slide__image");
    const totalSlides = allImageSlides.length;

    isProgrammaticScroll = true;
    currentIndex++;

    // Scroll to the next image slide (might be the clone of first)
    scrollMobileImageTo(currentIndex);
    updateMobileActiveSlide(currentIndex);

    // If we're now on the clone of first slide, jump to the first real slide after animation
    if (currentIndex === totalSlides - 1) {
      isTransitioning = true;
      setTimeout(() => {
        currentIndex = 1;
        scrollMobileImageTo(currentIndex, false);
        updateMobileActiveSlide(currentIndex);
        isTransitioning = false;
        isProgrammaticScroll = false;
      }, 400);
    } else {
      // Re-enable scroll listener after scroll completes
      setTimeout(() => {
        isProgrammaticScroll = false;
      }, 400);
    }
  }

  function handleMobilePrev() {
    if (isTransitioning || !mobileImageSlider) return;
    const allImageSlides = mobileImageSlider.querySelectorAll(".unified-slide__image");
    const totalSlides = allImageSlides.length;
    const lastRealIndex = totalSlides - 2; // Last real slide (before clone of first)

    isProgrammaticScroll = true;
    currentIndex--;

    // Scroll to the previous image slide (might be the clone of last)
    scrollMobileImageTo(currentIndex);
    updateMobileActiveSlide(currentIndex);

    // If we're now on the clone of last slide, jump to the last real slide after animation
    if (currentIndex === 0) {
      isTransitioning = true;
      setTimeout(() => {
        currentIndex = lastRealIndex;
        scrollMobileImageTo(currentIndex, false);
        updateMobileActiveSlide(currentIndex);
        isTransitioning = false;
        isProgrammaticScroll = false;
      }, 400);
    } else {
      // Re-enable scroll listener after scroll completes
      setTimeout(() => {
        isProgrammaticScroll = false;
      }, 400);
    }
  }

  // Navigate to a specific slide (for tab clicks)
  // Note: productIndex is the real product index (0-based, no clones)
  function navigateToMobileSlide(productIndex) {
    if (!mobileSliderContainer || !mobileImageSlider) return;

    // Convert product index to slider index (add 1 for the clone at the beginning)
    const slideIndex = productIndex + 1;

    const allImageSlides = mobileImageSlider.querySelectorAll(".unified-slide__image");
    if (slideIndex < 0 || slideIndex >= allImageSlides.length) return;

    // Set flag to prevent scroll listener from interfering
    isProgrammaticScroll = true;

    currentIndex = slideIndex;

    // Scroll image slider to position
    scrollMobileImageTo(currentIndex);

    // Update active states (cards will fade via CSS)
    updateMobileActiveSlide(currentIndex);

    // Re-enable scroll listener after scroll completes
    setTimeout(() => {
      isProgrammaticScroll = false;
    }, 400);
  }

  // ===========================================
  // DESKTOP: Fade transitions with infinite scroll
  // ===========================================
  let desktopCurrentIndex = 1; // Starts at 1 due to cloned slides

  function initDesktop() {
    if (!productCardSlider || !imageSlider) return;

    let productCards = document.querySelectorAll(".selector__product-card");
    let productImages = imageSlider.querySelectorAll("picture");
    const realSlideCount = productCards.length;

    // Clone for infinite scroll
    if (!productCardSlider.querySelector(".selector__product-card[data-cloned]")) {
      const firstCard = productCards[0].cloneNode(true);
      firstCard.classList.remove("active");
      firstCard.setAttribute("data-cloned", "true");
      productCardSlider.appendChild(firstCard);
      productCardSlider.insertBefore(
        productCards[realSlideCount - 1].cloneNode(true),
        productCards[0]
      );

      imageSlider.appendChild(productImages[0].cloneNode(true));
      imageSlider.insertBefore(
        productImages[productImages.length - 1].cloneNode(true),
        productImages[0]
      );
    }

    productCards = document.querySelectorAll(".selector__product-card");
    productImages = imageSlider.querySelectorAll("picture");
    const allCards = Array.from(productCards);
    const allImages = Array.from(productImages);

    const imageWidth = imageSlider.offsetWidth + 24;
    imageSlider.scrollLeft = imageWidth;

    productCardSlider.classList.add("selector__product-card-wrapper--positioned");

    allCards.forEach((card, i) => {
      card.classList.add("selector__product-card--positioned");
      if (i === desktopCurrentIndex) {
        card.classList.add("selector__product-card--active");
        card.classList.remove("selector__product-card--inactive");
        card.classList.add("active");
        productCardSlider.style.height = card.offsetHeight + "px";
      } else {
        card.classList.add("selector__product-card--inactive");
        card.classList.remove("selector__product-card--active");
        card.classList.remove("active");
      }
    });

    allImages.forEach((img, i) => {
      if (i === desktopCurrentIndex) {
        img.style.opacity = "1";
        img.classList.add("active");
      } else {
        img.style.opacity = "0";
        img.classList.remove("active");
      }
    });

    applyPreservedState(allCards[desktopCurrentIndex]);
  }

  function updateDesktopActiveClass(index) {
    const allCards = Array.from(document.querySelectorAll(".selector__product-card"));
    const allImages = Array.from(imageSlider.querySelectorAll("picture"));

    allCards.forEach((card, i) => {
      if (i === index) {
        card.classList.add("selector__product-card--active", "active");
        card.classList.remove("selector__product-card--inactive");
        productCardSlider.style.height = card.offsetHeight + "px";
        applyPreservedState(card);
      } else {
        card.classList.add("selector__product-card--inactive");
        card.classList.remove("selector__product-card--active", "active");
      }
    });

    allImages.forEach((img, i) => {
      img.style.transition = "opacity 0.3s ease-in-out";
      if (i === index) {
        img.style.opacity = "1";
        img.classList.add("active");
      } else {
        img.style.opacity = "0";
        img.classList.remove("active");
      }
    });

    // Update product tab buttons
    updateDesktopProductTabButtons(index);

    // Clear any stuck active/focus states
    blurAllInteractiveElements();
  }

  function updateDesktopProductTabButtons(index) {
    const productTabs = document.querySelectorAll(".selector__product-tab:not(.selector__product-tab--mobile)");
    if (productTabs.length === 0) return;

    const realProductCount = productTabs.length;

    // Account for cloned slides
    let realIndex = index - 1;
    if (realIndex < 0) {
      realIndex = realProductCount - 1;
    } else if (realIndex >= realProductCount) {
      realIndex = 0;
    }

    productTabs.forEach((tab) => {
      const tabProductIndex = parseInt(tab.dataset.productIndex, 10);
      if (tabProductIndex === realIndex) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });
  }

  function scrollDesktopTo(index, animated = true) {
    const imageWidth = imageSlider.offsetWidth + 24;
    imageSlider.scrollTo({
      left: index * imageWidth,
      behavior: animated ? "smooth" : "auto",
    });
  }

  function handleDesktopNext() {
    if (isTransitioning) return;
    const allCards = Array.from(document.querySelectorAll(".selector__product-card"));
    desktopCurrentIndex++;
    scrollDesktopTo(desktopCurrentIndex);
    updateDesktopActiveClass(desktopCurrentIndex);

    if (desktopCurrentIndex === allCards.length - 1) {
      isTransitioning = true;
      setTimeout(() => {
        desktopCurrentIndex = 1;
        scrollDesktopTo(desktopCurrentIndex, false);
        updateDesktopActiveClass(desktopCurrentIndex);
        isTransitioning = false;
      }, 600);
    }
  }

  function handleDesktopPrev() {
    if (isTransitioning) return;
    const allCards = Array.from(document.querySelectorAll(".selector__product-card"));
    desktopCurrentIndex--;
    scrollDesktopTo(desktopCurrentIndex);
    updateDesktopActiveClass(desktopCurrentIndex);

    if (desktopCurrentIndex === 0) {
      isTransitioning = true;
      setTimeout(() => {
        desktopCurrentIndex = allCards.length - 2;
        scrollDesktopTo(desktopCurrentIndex, false);
        updateDesktopActiveClass(desktopCurrentIndex);
        isTransitioning = false;
      }, 600);
    }
  }

  // ===========================================
  // SHARED UTILITIES
  // ===========================================

  // Apply preserved state to active slide/card
  function applyPreservedState(element) {
    const card = element.classList.contains("unified-slide__card")
      ? element
      : element.querySelector(".unified-slide__card") || element;

    if (!card) return;

    const tabButtons = card.querySelectorAll(".selector__tab-button");
    const targetTab = Array.from(tabButtons).find(
      (btn) => btn.dataset.type === window.currentSelectedType
    );

    if (targetTab) {
      tabButtons.forEach((btn) => {
        btn.classList.toggle(
          "active",
          btn.dataset.type === window.currentSelectedType
        );
      });
      window.applyColors(targetTab.dataset);
      window.updateProductVariant(window.currentSelectedType, null, card);
    } else {
      const firstAvailableTab = tabButtons[0];
      if (firstAvailableTab) {
        window.currentSelectedType = firstAvailableTab.dataset.type;
        tabButtons.forEach((btn) => {
          btn.classList.toggle("active", btn === firstAvailableTab);
        });
        window.applyColors(firstAvailableTab.dataset);
        window.updateProductVariant(window.currentSelectedType, null, card);
      }
    }
  }

  // Clear stuck active/focus states on all interactive elements
  function blurAllInteractiveElements() {
    document.querySelectorAll(".selector__tab-button").forEach((btn) => btn.blur());
    document.querySelectorAll(".quantity__button").forEach((btn) => btn.blur());
    document.querySelectorAll(".selector__add-to-cart").forEach((btn) => btn.blur());
    document.querySelectorAll(".selector__buying-option").forEach((btn) => btn.blur());
  }

  // ===========================================
  // EVENT LISTENERS
  // ===========================================

  // Product tab button click handlers
  function attachProductTabListeners() {
    // Desktop tabs
    const desktopTabs = document.querySelectorAll(".selector__product-tab:not(.selector__product-tab--mobile)");
    desktopTabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        if (isTransitioning) return;
        const targetIndex = parseInt(tab.dataset.productIndex, 10);
        // Add 1 to account for cloned slide at beginning
        const slideIndex = targetIndex + 1;

        if (slideIndex !== desktopCurrentIndex) {
          desktopCurrentIndex = slideIndex;
          scrollDesktopTo(desktopCurrentIndex);
          updateDesktopActiveClass(desktopCurrentIndex);
        }
      });
    });

    // Mobile tabs - scroll images and fade cards
    // Note: Tab productIndex is 0-based for real products
    const mobileTabButtons = document.querySelectorAll(".selector__product-tab--mobile");
    mobileTabButtons.forEach((tab) => {
      tab.addEventListener("click", () => {
        if (isTransitioning) return;
        const targetProductIndex = parseInt(tab.dataset.productIndex, 10);

        // Convert current slider index to real product index for comparison
        const currentRealIndex = currentIndex - 1;

        if (targetProductIndex !== currentRealIndex) {
          navigateToMobileSlide(targetProductIndex);
        }
      });
    });
  }

  // Attach event listeners
  if (mobileNextBtn) mobileNextBtn.addEventListener("click", handleMobileNext);
  if (mobilePrevBtn) mobilePrevBtn.addEventListener("click", handleMobilePrev);
  if (desktopNextBtn) desktopNextBtn.addEventListener("click", handleDesktopNext);
  if (desktopPrevBtn) desktopPrevBtn.addEventListener("click", handleDesktopPrev);

  // Attach product tab button listeners
  attachProductTabListeners();

  // Initialize
  init();

  // Handle resize
  window.addEventListener("resize", () => {
    const wasMobile = document.body.classList.contains("mobile-view");
    const nowMobile = isMobile();

    if (wasMobile !== nowMobile) {
      // Reset indices: mobile starts at 1 (after clone), desktop at 1 (after clone)
      currentIndex = 1;
      desktopCurrentIndex = 1;
      isTransitioning = false;
      isProgrammaticScroll = false;
      init();
    }

    document.body.classList.toggle("mobile-view", nowMobile);
  });

  // Set initial class
  document.body.classList.toggle("mobile-view", isMobile());
});
